export default __webpack_public_path__ + "static/media/brand-PE.b5234c13.png";